// Test IDs for the Virtual Bookshelf feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const BOOKSHELF = {
	page: 'bookshelf-page',
	navLink: 'app-nav-bookshelf',
	header: 'bookshelf-header',
	overviewCard: 'bookshelf-overview',
	shelfNavigation: 'bookshelf-navigation',
	filterBar: 'bookshelf-filters',
	bookGrid: 'bookshelf-grid',
	bookCard: 'bookshelf-card',
	emptyState: 'bookshelf-empty',
	addBookModal: 'bookshelf-add-modal',
	createShelfModal: 'bookshelf-create-shelf-modal',
};
